import _css from "@emotion/css";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import theme from "../../themes/default";
import style from "./Badge.style";

const Badge = ({
  count,
  color,
  className
}) => ___EmotionJSX("div", {
  css:
  /*#__PURE__*/
  _css([style.badge.base({
    color
  }), count != null && style.badge.withCount], "label:Badge;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3RtcC93ZWIvY29tcG9uZW50cy9CYWRnZS9CYWRnZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiIuLi8uLi8uLi8uLi90bXAvd2ViL2NvbXBvbmVudHMvQmFkZ2UvQmFkZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCB0aGVtZSBmcm9tICckYXVsYS90aGVtZSc7XG5pbXBvcnQgc3R5bGUgZnJvbSAnLi9CYWRnZS53ZWIuc3R5bGUnO1xuXG5jb25zdCBCYWRnZSA9ICh7IGNvdW50LCBjb2xvciwgY2xhc3NOYW1lIH0pID0+IChcbiAgPGRpdlxuICAgIGNzcz17W1xuICAgICAgc3R5bGUuYmFkZ2UuYmFzZSh7IGNvbG9yIH0pLFxuICAgICAgY291bnQgIT0gbnVsbCAmJiBzdHlsZS5iYWRnZS53aXRoQ291bnQsXG4gICAgXX1cbiAgICBjbGFzc05hbWU9e2NsYXNzTmFtZX1cbiAgPlxuICAgIHtjb3VudCAhPSBudWxsICYmIDxzcGFuIGNzcz17c3R5bGUuY291bnQuYmFzZX0+e2NvdW50fTwvc3Bhbj59XG4gIDwvZGl2PlxuKTtcblxuQmFkZ2UuZGVmYXVsdFByb3BzID0ge1xuICBjb3VudDogdW5kZWZpbmVkLFxuICBjb2xvcjogdGhlbWUuY29sb3IuZGVzaWduU3lzdGVtLnN1Y2Nlc3MsXG4gIGNsYXNzTmFtZTogdW5kZWZpbmVkLFxufTtcblxuQmFkZ2UucHJvcFR5cGVzID0ge1xuICBjb3VudDogUHJvcFR5cGVzLm51bWJlcixcbiAgY29sb3I6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGNsYXNzTmFtZTogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFJlYWN0Lm1lbW8oQmFkZ2UpO1xuIl19 */")),
  className: className
}, count != null && ___EmotionJSX("span", {
  css: style.count.base
}, count));

Badge.defaultProps = {
  count: undefined,
  color: theme.color.designSystem.success,
  className: undefined
};
Badge.propTypes = {
  count: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string
};
export default React.memo(Badge);